import {alias, createModelSchema, custom, deserialize, serialize, SKIP} from "serializr";
import {Cloneable} from "@/common/Cloneable";

import {ItemRecycleMode} from "./ItemRecycleMode";
import {RewardModel} from "../../reward/RewardModel";

export class ItemRecycleConfig extends Cloneable {

    static schema() {
        return custom(
            (v) => {
                return v && !v.empty() ? serialize(ItemRecycleConfig, v) : SKIP;
            },
            (v) => {
                return deserialize(ItemRecycleConfig, v);
            }
        );
    }

    constructor() {
        super();
        this._mode = ItemRecycleMode.DISABLED;

        this._reward = null;
    }

    get mode() {
        return this._mode;
    }

    set mode(value) {
        this._mode = value;
    }

    get reward() {
        return this._reward;
    }

    set reward(value) {
        this._reward = value;
    }

    valid() {
        if (this.mode.equal(ItemRecycleMode.DISABLED)) {
            return true;
        } else if (this.reward && !this.reward.valid()) {
            return false;
        }

        return true;
    }

    empty() {
        return this.mode.equal(ItemRecycleMode.DISABLED);
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new ItemRecycleConfig());
        } else if (target instanceof ItemRecycleConfig) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(ItemRecycleConfig, {
    _mode: alias("mode", ItemRecycleMode.schema()),
    _reward: alias("reward", RewardModel.schema())
});